import { Notifications } from 'types/notifications'
import { isMainNZClient } from 'setups/controller'
import { projectClient } from 'constants/project'

// import { http } from 'utils'

/**
 * Get HDA notifications.
 *
 * @param instance Region
 */
export function getHDANotifications(instance: string): Notifications[] {
  // let url = `/notes/${traderId}`
  // const params = new URLSearchParams()

  // if (sourceName) {
  //   params.set('sourceName', sourceName)
  // }

  // if (noteType) {
  //   params.set('noteType', noteType)
  // }

  // if (startDate) {
  //   params.set('startDate', startDate)
  // }

  // if (endDate) {
  //   params.set('endDate', endDate)
  // }

  // if (priorityLevel) {
  //   params.set('priorityLevel', priorityLevel)
  // }

  // if (pNumber) {
  //   params.set('pNumber', pNumber.toString())
  // }

  // if (pSize) {
  //   params.set('pSize', pSize.toString())
  // }

  // url += `?${params.toString()}`

  // const response = await http.get<{ notes: Note[] }>(url)

  // const items = response.data.notes.map((record: Note) => ({
  //   noteType: record.noteType,
  //   priorityLevel: record.priorityLevel,
  //   sourceName: record.sourceName,
  //   lastModifiedDate: record.lastModifiedDate.replace(/\s/g, 'T'),
  //   noteDescription: record.noteDescription,
  //   noteId: record.noteId,
  // }))

  const updates = [
    {
      title: 'Merchant Module Added',
      description: 'You can now create and update merchant details and status.',
      date: '2023-11-05',
      project: 'subway',
    },
    {
      title: 'Merchant Transactions, Devices, and Identifications Tabs Added',
      description:
        'You can now add merchant devices and identifiers, and view merchant transactions.',
      date: '2023-11-05',
      project: 'subway',
    },
    {
      title: 'Transaction Reports now can be view/exported/downloaded in Transactions tab',
      description:
        'You can now view, export, and download member transaction reports as CSV or PDF.',
      date: '2025-10-23',
      project: 'subway',
    },
  ]

  if (isMainNZClient(projectClient)) {
    updates.push({
      title: 'Reports module added',
      description:
        'You can now generate merchant transaction reports and export them as CSV.',
      date: '2025-10-23',
      project: 'subway',
    })
  }

  return updates
}
